
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminSchoolSisDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationUuid"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationUuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sisSyncOverview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canNotifyTeachers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canNotifyStudents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canNotifyParents"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teacherCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"studentCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alertCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"syncStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"syncMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allIssuesDownloadUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastSyncTimestamp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"issueSummaries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"affectedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"affectedType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolution"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"holdSummary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permanentlyIgnoreable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"temporarilyIgnoreable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"affectedResourceCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reportDownloadUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"affectedResourcesSummary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rosteringPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canOnlySeeReviewScreen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOnlySeeRosteringStagingArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOnlySeeRosteringDashboard"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":979}};
    doc.loc.source = {"body":"query AdminSchoolSisDashboard($organizationUuid: [String!], $organizationId: [Int!]) {\n  organizations(ids: $organizationId, uuids: $organizationUuid) {\n    id\n    uuid\n    name\n    sisSyncOverview {\n      canNotifyTeachers\n      canNotifyStudents\n      canNotifyParents\n      parentCount\n      teacherCount\n      studentCount\n      errorCount\n      alertCount\n      syncStatus\n      syncMethod\n      allIssuesDownloadUrl\n      lastSyncTimestamp\n      issueSummaries {\n        severity\n        affectedCount\n        affectedType\n        description\n        resolution\n        downloadUrl\n      }\n      holdSummary {\n        hold\n        permanentlyIgnoreable\n        temporarilyIgnoreable\n        affectedResourceCount\n        reportDownloadUrl\n        affectedResourcesSummary {\n          count\n          resource\n        }\n      }\n    }\n    rosteringPermissions {\n      canOnlySeeReviewScreen\n      canOnlySeeRosteringStagingArea\n      canOnlySeeRosteringDashboard\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["AdminSchoolSisDashboard"] = oneQuery(doc, "AdminSchoolSisDashboard");
        
